<div class="max-w mx-auto my-2 bg-white shadow-lg rounded-lg overflow-hidden">
  <!-- Conteneur de la carte -->
  <div class="flex">
    <!-- 1er tiers - Date -->
    <div class="w-1/3 bg-blue-100 flex items-center justify-center">
      <div class="text-center text-3xl font-bold text-blue-600">
        <!-- Affichage du jour et du mois -->
        <p class="text-md">{{ jourNumero }}</p>
        <p class="text-sm">{{ moisLibelle }}</p>
      </div>
    </div>

    <!-- 2/3 Restants - Informations sur le rendez-vous -->
    <div class="w-2/3 p-4">
      <p class="text-lg font-bold text-gray-900">Rendez-vous à {{ heure }} <i *ngIf="meeting.ticketNumber" [pTooltip]="'Ticket n° : '+ meeting.ticketNumber +' \n\r PIN : ' + meeting.ticketPin" class="pi pi-info-circle" ></i></p>
      <p class="text-md font-semibold text-gray-600 mt-4 my-0">{{ meeting.intervenantNom }}  {{meeting.intervenantPrenom}}</p>
      <p class="text-sm text-gray-500 ">{{ meeting.intervenantMission }}</p>
      <p class="text-sm text-gray-700 mt-4 flex items-center">
        <i class="pi pi-arrow-right mr-2"></i> {{ meeting.libelleTypeRdv }}
      </p>
      <p *ngIf="!meeting.visioLink" class="text-sm text-gray-700 mt-4 flex items-center">
          <i class="pi pi-arrow-right mr-2"></i> Site : {{ meeting.siteLibelle }}
      </p>
      <div class="mt-4 block xl:flex justify-center text-center" *ngIf="!meeting.annule">
        <!-- Boutons modifier et supprimer -->
        <div>
          <p-button severity="warn" class="mt-4 text-white rounded-lg mx-auto sm:mx-3" [disabled]="!allowCancel" (click)="updateMeeting()">Modifier</p-button>
        </div>
        <div class="mt-2 xl:mt-0">
          <p-button severity="danger" class="mt-2 lg:mt-0 text-white rounded-lg mx-auto sm:mx-3" [disabled]="!allowCancel" (click)="showDeleteDialog()">Annuler</p-button>
        </div>
      </div>
      <div class="mt-4 block xl:flex justify-center text-center">
        <!-- Boutons modifier et supprimer -->
        <div>
          <p-button severity="info" class="mt-4 text-white rounded-lg mx-auto sm:mx-3" *ngIf="meeting.visioLink && !past && !meeting.annule" (click)="openVisioLink(meeting)">Lancer la visio</p-button>
        </div>
      </div>
      <div *ngIf="meeting.annule" class="mt-4 p-4 rounded-lg bg-red-50 border border-red-200 text-red-700 flex flex-col items-start shadow-sm">
        <div class="flex items-center mb-2">
          <i class="pi pi-ban mr-2 text-xl"></i>
          <span class="font-semibold text-base">Ce rendez-vous a été annulé</span>
        </div>
        <div *ngIf="meeting.dateAnnulation" class="flex items-center text-sm mt-1">
          <i class="pi pi-calendar mr-2"></i>
          <span>Date d'annulation :</span>
          <span class="ml-2 font-semibold">{{ meeting.dateAnnulation | date:'dd/MM/yyyy à HH:mm' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog header="Confirmer l'annulation" [(visible)]="deleteDialogVisible" [modal]="true" [style]="{ width: '50rem' }">
  <p>Êtes-vous sûr de vouloir annuler ce rendez-vous ?</p>
  <div *ngIf="isLoading" class="flex justify-center">
    <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
  </div>

  <ng-template #footer>
      <p-button label="Non, conserver" [text]="true" severity="secondary" (click)="deleteDialogVisible = false" />
      <p-button label="Oui, annuler" [outlined]="true" severity="danger" (click)="deleteMeeting()" />
  </ng-template>
</p-dialog>

